import React from "react";
import "./LoaderLogo.css";
import { greeting } from "../../portfolio";

export default function LoaderLogo({ theme }) {
  return (
    <div
      className="samer-loader"
      style={{
        "--loader-gold": theme.gold,
        "--loader-text": theme.text,
        "--loader-bg": theme.body,
      }}
      role="img"
      aria-label={greeting.logo_name}
    >
      <div className="samer-loader-emblem" aria-hidden="true">
        <svg viewBox="0 0 240 240" className="samer-loader-orbit">
          <path
            className="loader-guide"
            d="M120 18 208 69v102l-88 51-88-51V69Z"
          />
          <path
            className="loader-inner-frame"
            d="M120 29 198 74v92l-78 45-78-45V74Z"
          />
          <path
            className="loader-ring"
            d="M120 18 208 69v102l-88 51-88-51V69Z"
            pathLength="1"
          />
          <path d="m120 14 4 4-4 4-4-4Z" fill="currentColor" />
        </svg>
        <strong className="samer-loader-initials">SJ</strong>
        <span className="loader-symbol loader-code">
          <svg
            viewBox="0 0 32 32"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="m10 10-6 6 6 6m12-12 6 6-6 6M18 7l-4 18" />
          </svg>
        </span>
        <span className="loader-symbol loader-chemistry">
          <svg
            viewBox="0 0 32 32"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M12 4h8m-6 0v9L6 25q-1 3 3 3h14q4 0 3-3l-8-12V4M10 20h12" />
            <circle cx="15" cy="23" r="1" fill="currentColor" />
          </svg>
        </span>
      </div>
      <div className="samer-loader-signature" aria-hidden="true">
        <span>{greeting.logo_name}</span>
      </div>
    </div>
  );
}
